import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CloseGrievanceDialogComponent } from 'src/app/grievance/close-grievance-dialog/close-grievance-dialog.component';
import { CommonFunction } from 'src/app/grievance/common-function';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { EscalationDurationService } from '../escalation-duration.service';

export class EscalationList {
  pkEsId: any;
  boardName: any;
  departmentName: any;
  grievanceType: any;
  esLevel: string;
  esDays: any;
}

const COLS = [
  { value: "ESCALATION ID", lowercaseValue: "pkEsId", displayName: "Escalation Id" },
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "grievanceType", displayName: "Grievance Type" },
  { value: "LEVEL", lowercaseValue: "esLevel", displayName: "Level" },
  { value: "DURATION", lowercaseValue: "esDays", displayName: "Escalation days" },
];

@Component({
  selector: 'app-list-escalation-duration',
  templateUrl: './list-escalation-duration.component.html',
  styleUrls: ['./list-escalation-duration.component.scss'],
})

export class ListEscalationDurationComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  loading = true
  progressSpinnerDialog: any = null;
  escalationList: EscalationList[] = [];
  displayedColumns: any[];
  escalationDuration: boolean;
  id: any;
  content: any;
  noEscalationData = ProjectConstants.esacalationNotAvailable
  dataSource = new MatTableDataSource(this.escalationList);
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 

  constructor(public escalationService: EscalationDurationService,
    public commonFunction:CommonFunction,
    public router: Router,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    this.displayedCols = [
      { value: "ESCALATION ID", lowercaseValue: "pkEsId", displayName: "Escalation Id" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "grievanceType", displayName: "Grievance Type" },
      { value: "LEVEL", lowercaseValue: "esLevel", displayName: "Level" },
      { value: "DURATION", lowercaseValue: "esDays", displayName: "Escalation days" },
    ];
    this.dataSource.paginator = this.paginator;
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.loadList();
   
  }


  async loadList() {
    this.displayProgressSpinner();
    const response: any = await this.escalationService.getAllGrievanceEscalation(this.id)
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            const customObj = new EscalationList();
            customObj.pkEsId = response[i].pkEsId
            customObj.boardName = response[i].boardName
            customObj.grievanceType = response[i].grievanceType
            customObj.esLevel = response[i].esLevel
            customObj.esDays = response[i].esDays
            customObj.departmentName = response[i].departmentName
            this.escalationList.push(customObj)
          }
          this.dataSource.data = this.escalationList;
        } else if (response[0].status == ProjectConstants.responseStatusFailure) {
          // this.errorToast();
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        this.escalationList = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      this.dataSource.data = this.escalationList;
    }
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  updateEscalationDuration(pkEsId) {
    this.router.navigate(['secure/update-escalation-duration/' + pkEsId])
  }

  deleteEscalationDuration(pkEsId) {
    const dialogRef = this.dialog.open(CloseGrievanceDialogComponent, {
      width: 'fit-content',
      data: { id: 'delete', content: "Escalation Duration" },
    });
    dialogRef.afterClosed().subscribe(async result => {
      var returnval = result;
      if (returnval == ProjectConstants.noMsg) {
        this.escalationDuration = false
      } else {
        this.escalationDuration = true
        this.displayProgressSpinner();
        const response: any = await this.escalationService.deleteEscalationDuration(pkEsId)
        this.progressSpinnerDialog.close()
        if (response != null && !response.error) {
          if (response.status === ProjectConstants.responseStatusSuccess) {
            // this.successToast();
            await this.commonFunction.successToast(ProjectConstants.esaclationDeleteSuccessMsg,false,"")
            window.location.reload()
          }
          else if (response.status === ProjectConstants.responseStatusFailure) {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }

      }
    });
  }

  addEscalationDuration() {
    this.router.navigate(['secure/add-escalation-duration/' + this.id])
  }


  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
